import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import FormField from '@/components/form-field';
import RepayChoicePopUp from '@/components/repay-choice-pop';
import type { CalcPlanListData, ApplyChannelData } from '@/api/apply-product/types';
import { RateTypeEnum } from '@/api/apply-product/types';
import { getShowRateValue } from '@/components/repay-choice-pop/until';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

/** 怎么还-还款类型模块 默认按期还，可选 灵活还（随借随还，按日计息） */
@Component
export default class RepayChoice extends Vue {
  @ApplyProductStore.State repayOnSchedule!: boolean;

  @ApplyProductStore.State planListData!: CalcPlanListData;

  @ApplyProductStore.State channel!: ApplyChannelData | undefined;

  private choiceContentData: {
    name: string;
    rate: number;
    des: string;
    repayOnSchedule: boolean;
  }[] = [];

  @Watch('planListData', { immediate: true })
  private updateContentData() {
    if (this.planListData) {
      this.choiceContentData = [
        {
          name: '按期还',
          rate: this.planListData.bonusRateValue as number,
          des: '笔笔还款返现金',
          repayOnSchedule: true,
        },
        {
          name: '灵活还',
          rate: this.planListData.rateValue,
          des: '按日计息更灵活',
          repayOnSchedule: false,
        },
      ];
    }
  }

  /** 按期还 选中第一个 */
  private get selectData() {
    return this.repayOnSchedule
      ? this.choiceContentData[0] : this.choiceContentData[1];
  }


  private renderRepayChoiceContent() {
    const { rateType = '' } = this.channel || {};
    return (
      <div class={style.choiceContent}>
        <div class={style.topItem}>
          {this.selectData.name}
          {
            this.selectData.repayOnSchedule && (
              <span class={style.topIcon}>利率低</span>
            )
          }
        </div>
        <div class={style.bottomItem}>
          {
            rateType !== RateTypeEnum.CAPITAL_TYPE_36
              ? `综合年化利率${getShowRateValue(this.selectData.rate)}%(单利)，` : ''
          }{this.selectData.des}
        </div>
      </div>
    );
  }

  private render() {
    return (
      <section>
        <FormField
          name="怎么还"
          needBottomDivider
          class={style.repayPlanField}
          onClick={this.showPop.bind(this)}
          >
            {this.choiceContentData.length > 0 && this.renderRepayChoiceContent()}
        </FormField>


        {/* 怎么还弹窗 */}
        {this.choiceContentData.length > 0
        && <RepayChoicePopUp
          ref="repayChoicePop"
          choiceContentData={this.choiceContentData}
        />}
      </section>
    );
  }

  private showPop() {
    this.$ubtPageButtonNew('finance_loan_apply_repayMode', {});
    (this.$refs.repayChoicePop as RepayChoicePopUp).showPopup(true);
  }
}
